import { useEffect, useState } from "react";
import { toast } from "react-hot-toast";
import { useSearch } from "../../../context/SearchContext";
import DeleteCard from "../../../Components/Cards/DeleteCard/DeleteCard";
import User_Form from "../../../Components/Forms/User/User_Form";
import "./AddUser.css";
import api from "../../../utils/api";

const AddUser = () => {
  const { search } = useSearch();
  const [data, setData] = useState([]);
  const [isModal, setIsModal] = useState(0);
  const [id, setId] = useState();
  const [isEdit, setIsEdit] = useState(false);
  const [editData, setEditData] = useState({});
  const [isCreate, setIsCreate] = useState(false);
  const [pagination, setPagination] = useState({
    page: 1,
    limit: 10,
    total: 0,
    totalPages: 0,
  });

  // Update pagination based on filtered data
  // useEffect(() => {
  //   const filteredData = data.filter(
  //     (user) =>
  //       user.name?.toLowerCase().includes(search.toLowerCase()) ||
  //       user.email?.toLowerCase().includes(search.toLowerCase()) ||
  //       user.phone?.toLowerCase().includes(search.toLowerCase()) ||
  //       user.role?.toLowerCase().includes(search.toLowerCase())
  //   );
  //   const total = filteredData.length;
  //   const totalPages = Math.ceil(total / pagination.limit);
  //   setPagination((prev) => ({
  //     ...prev,
  //     total,
  //     totalPages,
  //   }));
  // }, [data, search, pagination.limit]);

  const fetchUsers = async () => {
    const response = await api.get("/role/assign-role", {
      params: {
        page: pagination.page,
        limit: pagination.limit,
        search: search,
      },
    });
    setData(response.data.data);
    setPagination((prev) => ({
      ...prev,
      total: response.data.pagination.total,
      totalPages: response.data.pagination.totalPages,
    }));
  };

  useEffect(() => {
    fetchUsers();
  }, [pagination.page, pagination.limit, search]);

  const handlePageChange = (newPage) => {
    setPagination((prev) => ({
      ...prev,
      page: newPage,
    }));
  };

  const handleEditSave = async (updatedData) => {
    try {
      await api.put(`/role/assign-role/${updatedData.id}`, updatedData);
      toast.success("User updated successfully!");
      setIsEdit(false);
      fetchUsers();
    } catch (error) {
      toast.error("Failed to update user");
    }
  };

  const handleDelete = async () => {
    try {
      await api.delete(`/role/assign-role/${id}`);
      setIsModal(0);
      toast.success("User deleted successfully!");
      fetchUsers();
    } catch (error) {
      toast.error("Failed to delete user");
    }
  };

  const handleCreate = async (newUser) => {
    try {
      await api.post("/role/assign-role", newUser);
      toast.success("User created successfully!");
      setIsCreate(false);
      fetchUsers();
    } catch (error) {
      toast.error("Failed to create user");
    }
  };

  const paginatedData = data.filter((user) => user.first_name?.toLowerCase().includes(search.toLowerCase()) || user.last_name?.toLowerCase().includes(search.toLowerCase()) || user.phone?.toLowerCase().includes(search.toLowerCase()) || user.role?.toLowerCase().includes(search.toLowerCase())).slice((pagination.page - 1) * pagination.limit, pagination.page * pagination.limit);

  return (
    <div className="user">
      <div className="user__top">
        <div className="user__top_button_left_most">
          <button type="button" className="user__top_button_circular" onClick={() => setIsCreate(true)}>
            Add User
          </button>
        </div>
      </div>
      {isModal === 1 ? <DeleteCard btn="DELETE" del={handleDelete} msg="Are you sure you want to delete this user?" close={() => setIsModal(0)} /> : null}
      {isEdit && <User_Form onClose={() => setIsEdit(false)} onSubmit={handleEditSave} isEdit={isEdit} data={editData} />}
      {isCreate && <User_Form onClose={() => setIsCreate(false)} onSubmit={handleCreate} isEdit={false} data={{}} />}
      <div className="user__middle">
        <table>
          <thead>
            <tr className="user__middle_tr">
              <th className="user__middle_th">First Name</th>
              <th className="user__middle_th">Last Name</th>
              <th className="user__middle_th">Phone</th>
              <th className="user__middle_th">Role</th>
              <th className="user__middle_th"></th>
            </tr>
          </thead>
          <tbody>
            {paginatedData.map((user) => (
              <tr className="user__middle_tr" key={user.id}>
                <td className="user__middle_td">{user.first_name?.toUpperCase() || "-"}</td>
                <td className="user__middle_td">
                  <a href={`mailto:${user.last_name || "-"}`}>{user.last_name?.toUpperCase() || "-"}</a>
                </td>
                <td className="user__middle_td">{user.mobile_number?.toString() || "-"}</td>
                <td className="user__middle_td">{user.role_name?.toLowerCase() || "-"}</td>
                <td className="user__middle_td">
                  <button
                    type="button"
                    className="user__middle_td_edit"
                    onClick={() => {
                      setIsEdit(true);
                      setEditData(user);
                      setIsModal(0);
                    }}
                  >
                    Edit
                  </button>
                  <button
                    type="button"
                    className="user__middle_td_delete"
                    onClick={() => {
                      setId(user.id);
                      setIsModal(1);
                    }}
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Pagination */}
      <div
        className="pagination-controls"
        style={{
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
          marginTop: "20px",
          gap: "10px",
        }}
      >
        <button
          onClick={() => handlePageChange(pagination.page - 1)}
          disabled={pagination.page === 1}
          style={{
            padding: "5px 10px",
            cursor: pagination.page === 1 ? "not-allowed" : "pointer",
            opacity: pagination.page === 1 ? 0.5 : 1,
          }}
        >
          Previous
        </button>
        <span>
          Page {pagination.page} of {pagination.totalPages}
        </span>
        <button
          onClick={() => handlePageChange(pagination.page + 1)}
          disabled={pagination.page === pagination.totalPages}
          style={{
            padding: "5px 10px",
            cursor: pagination.page === pagination.totalPages ? "not-allowed" : "pointer",
            opacity: pagination.page === pagination.totalPages ? 0.5 : 1,
          }}
        >
          Next
        </button>
        <div style={{ marginLeft: "20px" }}>
          <label htmlFor="limit-select" style={{ marginRight: "10px" }}>
            Items per page:
          </label>
          <select
            id="limit-select"
            value={pagination.limit}
            onChange={(e) => {
              setPagination((prev) => ({
                ...prev,
                limit: Number(e.target.value),
                page: 1,
              }));
            }}
            style={{
              padding: "5px",
              borderRadius: "4px",
              border: "1px solid #ccc",
              backgroundColor: "rgb(239,239,239)",
            }}
          >
            <option value="10">10</option>
            <option value="20">20</option>
            <option value="50">50</option>
            <option value="100">100</option>
          </select>
        </div>
      </div>
    </div>
  );
};

export default AddUser;
